//@flow
import React, { Component } from "react";

type Props = {
  quantity: number,
  onAddQuantity: () => void,
  onDeductQuantity: () => void
};

class Quanity extends Component<Props> {
  render() {
    const quantity: number = this.props.quantity;
    const { onAddQuantity, onDeductQuantity } = this.props;
    return (
      <div className="wishlist-tile__options">
        <div className="qty-amount-switch wishlist-tile__amount-switch">
          <button
            className="qty-amount-switch__btn wishlist-tile__btn-dec--js"
            onClick={onDeductQuantity}
          >
            <i className="zmdi zmdi-minus" />
          </button>
          <span className="qty-amount-switch__field-wrapper">
            <input
              type="number"
              readOnly
              min="0"
              max="999"
              value={quantity}
              size="3"
              className="qty-amount-switch__field wishlist-tile__qty-field--js"
            />
          </span>
          <button
            className="qty-amount-switch__btn wishlist-tile__btn-inc--js"
            onClick={onAddQuantity}
          >
            <i className="zmdi zmdi-plus" />
          </button>
        </div>
      </div>
    );
  }
}

export default Quanity;
